// `typeName` (optional) is the short product type used to title per-brand cards on category pages,
// e.g. "Siniat" + "Skimming & Jointing Plaster". Falls back to `title`.
export const products = [
  {
    id: 1,
    categoryId: 'ceiling',
    title: 'Ceiling Tiles',
    summary: 'Vinyl, acoustic tiles and exposed grid in white, black & grey',
    description:
      'Vinyl and acoustic ceiling tiles in a wide range of styles and sizes. Sourced from top manufacturers including OWA and SuperTec.',
    features: [
      'Vinyl and acoustic options',
      'Multiple styles and sizes',
      'Easy maintenance',
      'Durable and long-lasting',
      'Acoustic performance rated',
    ],
    applications: ['Offices', 'Retail', 'Healthcare', 'Education'],
    brandIds: ['owa', 'supertec'],
  },
  {
    id: 2,
    categoryId: 'ceiling',
    title: 'Exposed Grid Systems',
    typeName: 'Exposed Grid',
    summary: 'Professional exposed grid systems in white, black & grey finishes',
    description:
      'Complete exposed grid ceiling systems available in white, black and grey finishes. Professional-grade components for clean, modern interiors.',
    features: [
      'White, black and grey finishes',
      'Easy installation',
      'Compatible with all tile sizes',
      'Durable steel construction',
      'Professional look',
    ],
    applications: ['Commercial', 'Offices', 'Retail', 'Industrial'],
    brandIds: ['gyproc', 'supertec'],
  },
  {
    id: 3,
    categoryId: 'ceiling',
    title: 'Plaster Grid',
    summary: 'Robust plaster grid for seamless plastered ceilings',
    description:
      'High-quality plaster grid systems for seamless plastered ceiling finishes. Robust and reliable for residential and commercial projects.',
    features: [
      'Seamless finish',
      'Strong and durable',
      'Easy to install',
      'Multiple profiles available',
      'Aluminium profiles',
      'Corrosion resistant',
    ],
    applications: ['Residential', 'Commercial', 'Renovations', 'New Builds'],
    brandIds: ['supertec'],
  },
  {
    id: 4,
    categoryId: 'drywall',
    title: 'Plasterboard',
    summary: 'Standard, moisture & fire resistant from Gyproc, Siniat & SuperTec',
    description:
      'High-quality plasterboard from Gyproc, Siniat and SuperTec — including moisture resistant, fire resistant and standard options for all construction needs.',
    features: [
      'Moisture resistant options',
      'Fire resistant options',
      'Standard and speciality boards',
      'Smooth surface finish',
      'Impact resistant options',
    ],
    applications: ['Walls', 'Ceilings', 'Partitions', 'Wet Areas'],
    brandIds: ['gyproc', 'siniat', 'supertec'],
  },
  {
    id: 5,
    categoryId: 'drywall',
    title: 'Steel Brandering & Components',
    typeName: 'Steel Brandering',
    summary: 'Steel framing and partitioning components',
    description:
      'Complete range of steel brandering and partition components for drywall framing. Precision-manufactured for accurate, reliable installations.',
    features: [
      'Light-gauge steel',
      'Precision manufactured',
      'Multiple sizes and profiles',
      'Corrosion resistant',
      'Easy to cut and install',
    ],
    applications: ['Wall Framing', 'Ceiling Framing', 'Partitions', 'Bulkheads'],
    brandIds: ['supertec'],
  },
  {
    id: 6,
    categoryId: 'drywall',
    title: 'Partitioning Components',
    summary: 'Tracks, studs, nogging, aluminium profiles and ancillary items',
    description:
      'All components needed for professional drywall partitioning — tracks, studs, nogging, aluminium profiles and ancillary items for fast, accurate builds.',
    features: [
      'Complete system approach',
      'Tracks, studs and nogging',
      'Aluminium profiles',
      'Acoustic rated options',
      'Fire rated options',
      'Bulk quantities available',
    ],
    applications: ['Office Partitions', 'Residential Walls', 'Acoustic Barriers', 'Fire Walls'],
    brandIds: ['supertec'],
  },
  {
    id: 7,
    categoryId: 'plasters',
    title: 'Plasters — Skimming & Jointing',
    typeName: 'Skimming & Jointing Plaster',
    summary: 'Skimming, jointing & patching from Siniat, Casofour & iTe',
    description:
      'Professional-grade skimming and jointing plasters for flawless finishes. Including 90-minute setting jointing compound for faster project turnaround.',
    features: [
      '90-minute setting compound',
      'Smooth skim finish',
      'Professional grade',
      'Easy to sand',
      'Low shrinkage',
    ],
    applications: ['Joint Finishing', 'Skim Coating', 'Patching', 'Repair Work'],
    brandIds: ['siniat', 'casofour', 'ite'],
  },
  {
    id: 8,
    categoryId: 'insulation',
    title: 'Insulation Materials',
    typeName: 'Insulation',
    summary: 'Knauf, Isotherm, Aerolite & Youngman Insulation',
    description:
      'Energy-efficient insulation from Knauf, Isotherm, Aerolite and Youngman Roofing & Insulation. Improve thermal performance, reduce energy costs, and meet green building standards.',
    features: [
      'Energy efficient',
      'Sound dampening',
      'Fire rated options',
      'Green building compliant',
      'Multiple R-value options',
    ],
    applications: ['Roofs', 'Walls', 'Floors', 'HVAC Systems'],
    brandIds: ['knauf-insulation', 'isover', 'aerolite', 'isotherm', 'youngmans'],
  },
  {
    id: 9,
    categoryId: 'acoustic',
    title: 'Acoustic Panels & Ceilings',
    typeName: 'Acoustic Panels',
    summary: 'Premium sound control from OWA & WoodUpp',
    description:
      'Acoustic wall panels and acoustic ceiling tiles for superior sound control. Ideal for auditoriums, offices, studios, and commercial spaces.',
    features: [
      'Multiple finish options',
      'Sound absorption rated',
      'Easy installation',
      'Aesthetic appeal',
      'NRC rated',
    ],
    applications: ['Auditoriums', 'Offices', 'Conference Rooms', 'Studios'],
    brandIds: ['owa', 'woodup'],
  },
  {
    id: 10,
    categoryId: 'accessories',
    title: 'Tools & Accessories',
    summary: 'Professional tools for ceiling & drywall work',
    description:
      'Professional tools and accessories for ceiling, drywall and plastering work. Everything you need to complete the job efficiently.',
    features: [
      'Professional grade',
      'Durable construction',
      'Ergonomic designs',
      'Complete range',
      'Competitive pricing',
    ],
    applications: ['Installation', 'Finishing', 'Cutting', 'Measuring'],
    brandIds: [],
  },
  {
    id: 11,
    categoryId: 'accessories',
    title: 'Fasteners',
    summary: 'Screws, anchors, rivets & clips',
    description:
      'Various fasteners including drywall screws, anchors, rivets and clips. Quality hardware for secure, lasting installations.',
    features: [
      'Drywall screws',
      'Anchors and rivets',
      'Ceiling clips',
      'Bulk packs available',
      'Corrosion resistant options',
    ],
    applications: ['Drywall Fixing', 'Ceiling Installation', 'Steel Framing', 'General Construction'],
    brandIds: [],
  },
  {
    id: 12,
    categoryId: 'access',
    title: 'Aluminium Ladders',
    summary: 'A-frame, extension & combination ladders',
    description:
      'Full range of aluminium ladders from MecoLadder — A-frame step ladders, extension ladders, single ladders, combination ladders and scaffolding towers for industrial, commercial and household use.',
    features: [
      'A-frame and extension options',
      'Heavy-duty and light-duty models',
      'Lightweight aluminium construction',
      'SANS-compliant safety standards',
      'Industrial and household ranges',
    ],
    applications: ['Construction', 'Maintenance', 'Industrial', 'Household'],
    brandIds: ['mecoladder'],
  },
  {
    id: 13,
    categoryId: 'access',
    title: 'Aluminium Door Frames',
    summary: 'Aluminium door frames for drywall applications',
    description:
      'Precision-manufactured aluminium door frames designed for drywall construction. Lightweight, corrosion-resistant and available in standard and custom sizes for residential and commercial projects.',
    features: [
      'Lightweight aluminium construction',
      'Corrosion resistant',
      'Standard and custom sizes',
      'Designed for drywall applications',
      'Single and double door configurations',
    ],
    applications: ['Drywall Partitions', 'Offices', 'Commercial', 'Residential'],
    brandIds: ['supertec', 'swartland'],
  },
  {
    id: 14,
    categoryId: 'access',
    title: 'Aluminium Glazing Sections',
    summary: 'Aluminium glazing sections for drywall & interior glazing',
    description:
      'Professional aluminium glazing sections for interior glazed partitions and drywall installations. Designed for clean sightlines and secure glass retention in commercial and residential environments.',
    features: [
      'Lightweight aluminium profiles',
      'Secure glass retention',
      'Multiple section profiles available',
      'Suitable for single and double glazing',
      'Corrosion resistant finish',
    ],
    applications: ['Glazed Partitions', 'Offices', 'Commercial Interiors', 'Showrooms'],
    brandIds: ['supertec', 'swartland'],
  },
];
